import CustomRoute from "components/ui/customs/routes/CustomRoute";
import backofficeConfig from "models/backoffice/backofficeConfig";

const BackofficeRoutes = CustomRoute(backofficeConfig);

export default BackofficeRoutes;
